const MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000

export function getDaysBetween(date1, date2) {
  const timeBetween = date2.getTime() - date1.getTime()
  return Math.floor(timeBetween / MILLISECONDS_PER_DAY)
}

export function isValidDate(date) {
  return date instanceof Date && !isNaN(date.getTime())
}
